import axios from "axios";
import {API_USERS, API_USERS_RESET_PASSWORD} from '../api.js';
import crudApi from "./crudApi";

class User extends crudApi{
    async resetPassword(id, options = {}) {
        return await axios.patch(API_USERS_RESET_PASSWORD(id), options);
    }
}

export default new User(API_USERS)
